import * as React from 'react';
import {
    BackNextSkip,
    TextInput,
    isValidAge,
    isValidEmail,
    requiredWithMinMaxLength,
    ruleRunner,
    clearValidation,
    TInvestor,
    run,
} from '@assetmark/common-elements/';
import { IProfile } from '../../profileComponent';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './about-you.css';
import styles from './about.module.css';

export interface AboutProps {
    onNextButtonClick: (event: any, data: IProfile) => void;
    onBackButtonClick: (event: any, data: IProfile) => void;
    data?: IProfile;
}

interface AboutState {
    data: IProfile;
    validationErrors: any;
    showErrors: boolean;
    isInvestorProfileComplete: boolean;
    buttonClass: string;
}

const fieldValidations = {
    FirstName: ruleRunner('FirstName', 'First Name', [
        requiredWithMinMaxLength(0, 30),
    ]),
    LastName: ruleRunner('LastName', 'Last Name', [
        requiredWithMinMaxLength(0, 30),
    ]),
    Age: ruleRunner('Age', 'Age', [isValidAge(0, 120)]),
    EmailAddress: ruleRunner('EmailAddress', 'Email Address', [isValidEmail]),
};

export class About extends React.Component<AboutProps, AboutState> {
    constructor(props) {
        super(props);

        const isInvestorProfileComplete = this.isInvestorProfileComplete(
            this.props.data,
        );

        this.state = {
            data: this.props.data,
            buttonClass: isInvestorProfileComplete ? '' : 'disabled',
            isInvestorProfileComplete: false,
            validationErrors: {},
            showErrors: false,
        };

        this.changeInvestorProfile = this.changeInvestorProfile.bind(this);
        this.saveInvestorProfile = this.saveInvestorProfile.bind(this);
        this.validateProfile = this.validateProfile.bind(this);
    }

    public changeInvestorProfile(e) {
        const tempInvestor = this.state.data;
        const field = e.target.name;
        tempInvestor.Investor[field] = e.target.value;
        this.setState({ data: tempInvestor });

        this.validateProfile(e.target.name, true)
    }

    componentDidMount() {

        const isInvestorProfileComplete = this.isInvestorProfileComplete(
            this.state.data.Investor,
            this.state.validationErrors,
        );

        this.setState({ isInvestorProfileComplete, buttonClass: isInvestorProfileComplete ? '' : 'disabled' })
    }

    public render() {
        return (
            <div className={`${styles.profilecomponent} col-sm-12`}>
                <h1 className={styles.title}>Name, Age, and Email</h1>

                <div className={`row ${styles.labeltext}`}>
                    <div className={`col-sm-12 ${styles.displayFlex}`}>
                        My name is &nbsp;
                        <div className={`${styles.posRelative}`}><TextInput
                            name="FirstName"
                            type="underline"
                            placeHolder="First Name"
                            className={`${styles.placeholderTextColor} first-name ${styles.nametext} ${this.state.validationErrors.FirstName && this.state.validationErrors.FirstName.length ? styles.errorlineinput : ''}`}
                            value={this.state.data.Investor.FirstName}
                            errorText={this.state.validationErrors.FirstName || ''}
                            showError={this.state.showErrors}
                            onChange={this.changeInvestorProfile}
                            onBlur={this.validateInvestorProfile}
                            onKeyPress={this.validateInvestorProfile}
                        /></div>
                        &nbsp;
                        <div className={`${styles.posRelative}`}><TextInput
                            name="LastName"
                            type="underline"
                            placeHolder="Last Name"
                            className={`${styles.placeholderTextColor} last-name ${styles.nametext} ${this.state.validationErrors.LastName && this.state.validationErrors.LastName.length ? styles.errorlineinput : ''}`}
                            value={this.state.data.Investor.LastName}
                            errorText={this.state.validationErrors.LastName || ''}
                            showError={this.state.showErrors}
                            onChange={this.changeInvestorProfile}
                            onBlur={this.validateInvestorProfile}
                            onKeyPress={() => this.validateProfile(this.state.data.Investor.LastName ? this.state.data.Investor.LastName : '', true)}
                        /></div>
                    </div>
                </div>

                <div className={`row ${styles.mtrow} ${styles.labeltext}`}>
                    <div className="col-sm-12">
                        My email address is &nbsp;
                        <TextInput
                            name="EmailAddress"
                            type="underline"
                            placeHolder="Email Address"
                            className={`${styles.placeholderTextColor} email ${styles.nametext} ${styles.emailtext} ${this.state.validationErrors.EmailAddress && this.state.validationErrors.EmailAddress.length ? styles.errorlineinput : ''}`}
                            value={this.state.data.Investor.EmailAddress}
                            errorText={this.state.validationErrors.EmailAddress || ''}
                            showError={this.state.showErrors}
                            onChange={this.changeInvestorProfile}
                            onBlur={this.validateInvestorProfile}
                            onKeyPress={() => this.validateProfile(this.state.validationErrors.EmailAddress ? this.state.validationErrors.EmailAddress : '', true)}
                        />
                    </div>
                </div>

                <div className={`row ${styles.mtrow} ${styles.labeltext}`}>
                    <div className="col-sm-12">
                        and I am &nbsp;
                        <TextInput
                            name="Age"
                            type="underline"
                            placeHolder="Age"
                            className={`${styles.placeholderTextColor} ${styles.agetext} ${styles.nametext} ${this.state.validationErrors.Age && this.state.validationErrors.Age.length ? styles.errorlineinput : ''}`}
                            maxLength={3}
                            value={
                                this.state.data.Investor.Age ? this.state.data.Investor.Age : ''
                            }
                            errorText={this.state.validationErrors.Age || ''}
                            showError={this.state.showErrors}
                            onChange={this.changeInvestorProfile}
                            onBlur={this.validateInvestorProfile}
                            onKeyPress={() => this.validateProfile(this.state.data.Investor.Age ? this.state.data.Investor.Age : '', true)}
                        />
                        &nbsp; years old
                    </div>
                </div>

                <div className={styles.mtrowbtn}>
                    <BackNextSkip
                        backButtonClassName={`button button-secondary button-lg ${styles.lineHeightClass}`}
                        nextButtonClassName={`button button-primary button-lg ml-2 ${this.state.buttonClass} ${styles.lineHeightClass}`}
                        onNextButtonClickHandler={this.saveInvestorProfile}
                        onBackButtonClickHandler={(e) =>
                            this.props.onBackButtonClick(e, {})
                        }
                        isDisabledNextButton={(this.state.validationErrors.FirstName && this.state.validationErrors.FirstName.length || this.state.validationErrors.LastName && this.state.validationErrors.LastName.length) ? true : false}
                    />
                </div>
            </div>
        );
    }

    private clearValidation = (field: any) => {
        return [ruleRunner(field, '', [clearValidation])];
    };

    private validateProfile = (field: any, onChange: boolean) => {
        const currentInvestor = this.state.data;
        // validationErrors contains errors from only the currently selected field
        const validationErrors = onChange
            ? run(currentInvestor.Investor, this.clearValidation(field))
            : run(currentInvestor.Investor, [fieldValidations[field]]);
        // updatedValidationErrors contains errors from all fields currently found
        const updatedValidationErrors = {
            ...this.state.validationErrors,
            ...validationErrors,
        };
        // will return true or false based if the investor profile has all the information (name, email, age)
        const isInvestorProfileComplete = this.isInvestorProfileComplete(
            currentInvestor.Investor,
            updatedValidationErrors,
        );
        // console.log(validationErrors, updatedValidationErrors);
        return this.setState({
            validationErrors: updatedValidationErrors,
            isInvestorProfileComplete,
            showErrors: true,
            buttonClass: isInvestorProfileComplete ? '' : 'disabled',
        });
    };

    // to be passed to the TextInput components onBlur (when input loses focus)
    private validateInvestorProfile = (e: any): void => {
        return this.validateProfile(e.target.name, false);
    };

    private isInvestorProfileComplete = (
        investor: any,
        validationErrors?: any,
    ): boolean => {
        if (
            investor.FirstName &&
            investor.LastName &&
            investor.EmailAddress.length > 0 &&
            isValidEmail(investor.EmailAddress).length === 0 &&
            investor.Age &&
            investor.Age >= 0 &&
            Number(investor.Age) &&
            investor.Age <= 120
        ) {
            return true;
        }

        if (
            validationErrors &&
            validationErrors.FirstName &&
            validationErrors.LastName &&
            validationErrors.EmailAddress &&
            validationErrors.Age
        ) {
            return false;
        }

        return false;
    };

    /*
      when user clicks on next, to go to next section, the state from this component will get saved
      to the profile-demo's state, so that the data gets saved when going to any other section, or even
      coming back to this component
      */
    private saveInvestorProfile(e) {
        if (
            this.isInvestorProfileComplete(
                this.state.data.Investor,
                this.state.validationErrors,
            )
        ) {
            // console.log("Investor profile is complete, some action will be performed", this.state.Investor);
            this.props.onNextButtonClick(e, this.state.data);
        }
    }
}
